import {GET_EVENTS} from '../../../constants/EventsConstants';
import {GeneralAction} from "../../../@types/actions";

export const GetEventsAction = (bookmakerId: number): GeneralAction<number> => ({
    type: GET_EVENTS,
    payload: bookmakerId
});